/** Traductions page inscription (FR / AR) */
export const registerPageFr = {
  bizDescBoucherie: 'Viande & Aliments Frais',
  bizDescRestaurant: 'Service Alimentaire & Opérations de Cuisine',
  bizDescSupermarche: 'Supermarché de Détail Complet',
  bizDescEpicerie: 'Épicerie & Articles Quotidiens',
  bizDescPharmacie: 'Pharmacie & Produits Médicaux',
  bizDescMagasin: 'Magasin de Détail Général',
  bizDescElectronique: 'Électronique, Accessoires & Gadgets',
  bizDescBricolage: 'Éclairage, portes, sanitaire, quincaillerie & matériaux (type Bauhaus)',
  bizDescMauritanianMarket: 'Marché Traditionnel Mauritanien',
  errInvalidImage: 'Veuillez sélectionner un fichier image valide',
  errFileTooLarge: 'La taille du fichier doit être inférieure à 512 Ko',
  errSelectBusinessType: 'Veuillez sélectionner le type d\'entreprise',
  errBusinessName: 'Veuillez saisir le nom de l\'entreprise',
  errOwnerName: 'Veuillez saisir le nom du propriétaire',
  errNif: 'Veuillez saisir le numéro NIF',
  errPhone: 'Veuillez saisir le numéro de téléphone',
  errAddress: 'Veuillez saisir l\'adresse',
  errEmail: 'Veuillez saisir l\'adresse e-mail',
  errUsername: 'Veuillez saisir le nom d\'utilisateur',
  errUsernameMin: 'Le nom d\'utilisateur doit contenir au moins 3 caractères',
  errPassword: 'Veuillez saisir le mot de passe',
  errPasswordMin: 'Le mot de passe doit contenir au moins 8 caractères, une lettre et un chiffre',
  errPasswordMismatch: 'Les mots de passe ne correspondent pas',
  errManagerCode: 'Veuillez saisir le code manager',
  errManagerCodeMin: 'Le code manager doit contenir au moins 2 caractères',
  errInvalidEmail: 'Format d\'email invalide',
  errUsernameTaken: 'Ce nom d\'utilisateur ou cette adresse e-mail est déjà utilisée',
  errCloudRegister: 'Échec de l\'inscription sur le serveur. Vérifiez la connexion ou réessayez.',
  errCloudOfflineOrUnconfigured:
    'Inscription locale uniquement (hors ligne).',
  errRegisterFailed: 'Échec de l\'inscription',
  errRegisterRetry: 'Échec de l\'inscription. Veuillez réessayer.',
  registrationNotAllowed: 'Cette installation est déjà configurée. Une seule entreprise par installation. Utilisez la connexion.',
  errMachineBinding: 'Cette installation est liée à un autre ordinateur. L\'inscription sur ce PC n\'est pas autorisée.',
  back: 'Retour',
  successTitle: 'Inscription réussie !',
  successLocalOnly1:
    'Compte créé sur cet appareil. Il sera poussé vers Supabase dès qu’Internet est disponible (file d’attente cloud). L’admin ne voit que les lignes cloud dans businesses.',
  successLocalOnly2: '',
  successCloudPending:
    'Demande enregistrée dans Supabase (statut « en attente »). L’administrateur peut l’approuver dans le tableau de bord admin.',
  successEmailPending:
    'Compte Auth créé. Confirmez l’e-mail si demandé. L’admin voit la ligne businesses après le trigger / push cloud.',
  goToDashboard: 'Aller au tableau de bord',
  installBindingNotice: 'Cette installation sera liée à cet ordinateur uniquement. Ne copiez pas le dossier de l\'application sur un autre PC — utilisez l\'installateur officiel.',
  successOnboardingTitle: 'Prochaines étapes',
  successOnboardingManager: 'Notez votre code manager : {code} (accès paramètres travailleurs).',
  successOnboardingCurrency: 'Devise configurée : {currency}. Modifiable dans les paramètres.',
  successOnboardingStep1: 'Ajoutez vos produits et enregistrez vos achats.',
  successOnboardingStep2: 'Configurez la caisse POS et les travailleurs si nécessaire.',
  successOnboardingStep3: 'Utilisez le code manager pour accéder aux paramètres avancés.',
  stepBusinessType: 'Type d\'Entreprise',
  stepBusinessInfo: 'Infos Entreprise & Compte',
  selectBusinessTypeTitle: 'Type d\'Entreprise',
  selectBusinessTypeDesc: 'Sélectionnez votre type d\'entreprise',
  businessInfoTitle: 'Informations Entreprise & Compte',
  businessInfoDesc: 'Saisissez les informations de votre entreprise et les détails du compte',
  next: 'Suivant',
  previous: 'Précédent',
  createAccount: 'Créer le Compte',
  alreadyHaveAccount: 'Vous avez déjà un compte ?',
  signInLink: 'Se connecter',
  showPassword: 'Afficher le mot de passe',
  hidePassword: 'Masquer le mot de passe',
  passwordHint: 'Min. 8 caractères, une lettre et un chiffre',
  labelBusinessName: 'Nom de l\'Entreprise *',
  placeholderBusinessName: 'Saisissez le nom de l\'entreprise',
  labelLogo: 'Logo de l\'Entreprise',
  removeLogo: 'Supprimer',
  clickChooseLogo: 'Cliquez pour choisir le logo',
  logoFormatHint: '(PNG, JPG, max 512 Ko)',
  labelOwnerName: 'Nom du Propriétaire *',
  placeholderOwnerName: 'Saisissez le nom du propriétaire',
  labelNif: 'Numéro NIF *',
  placeholderNif: 'Saisissez le numéro NIF',
  labelPhone: 'Numéro de Téléphone *',
  placeholderPhone: 'Saisissez le numéro de téléphone',
  labelAddress: 'Adresse *',
  placeholderAddress: 'Saisissez l\'adresse',
  labelCurrency: 'Devise *',
  currencyMRO: 'Ouguiya (MRO) — ancienne monnaie',
  currencyMRU: 'Ouguiya (MRU) — nouvelle monnaie',
  currencyHint: 'Utilisée pour les prix et les rapports. Modifiable plus tard dans les paramètres.',
  labelEmail: 'Adresse E-mail *',
  placeholderEmail: 'Saisissez l\'adresse e-mail',
  labelUsername: 'Nom d\'Utilisateur *',
  placeholderUsername: 'Saisissez le nom d\'utilisateur',
  labelPassword: 'Mot de Passe *',
  placeholderPassword: 'Saisissez le mot de passe',
  labelConfirmPassword: 'Confirmer le Mot de Passe *',
  placeholderConfirmPassword: 'Confirmez le mot de passe',
  labelManagerCode: 'Code Manager *',
  placeholderManagerCode: 'Saisissez le code manager (min 2 caractères)',
  managerCodeHint: 'Ce code sera utilisé pour accéder aux paramètres de gestion des travailleurs'
};

export const registerPageAr = {
  bizDescBoucherie: 'لحوم وأطعمة طازجة',
  bizDescRestaurant: 'خدمة الطعام وعمليات المطبخ',
  bizDescSupermarche: 'سوبر ماركت تجزئة شامل',
  bizDescEpicerie: 'بقالة ومستلزمات يومية',
  bizDescPharmacie: 'صيدلية ومستحضرات طبية',
  bizDescMagasin: 'متجر تجزئة عام',
  bizDescElectronique: 'إلكترونيات وملحقات وأجهزة',
  bizDescBricolage: 'إضاءة وأبواب وصحي وعدد ومواد بناء (مثل Bauhaus)',
  bizDescMauritanianMarket: 'السوق التقليدي الموريتاني',
  errInvalidImage: 'يرجى اختيار ملف صورة صالح',
  errFileTooLarge: 'حجم الملف يجب أن يكون أقل من 512 كيلوبايت',
  errSelectBusinessType: 'يرجى اختيار نوع الشركة',
  errBusinessName: 'يرجى إدخال اسم الشركة',
  errOwnerName: 'يرجى إدخال اسم المالك',
  errNif: 'يرجى إدخال رقم NIF',
  errPhone: 'يرجى إدخال رقم الهاتف',
  errAddress: 'يرجى إدخال العنوان',
  errEmail: 'يرجى إدخال البريد الإلكتروني',
  errUsername: 'يرجى إدخال اسم المستخدم',
  errUsernameMin: 'اسم المستخدم يجب أن يكون 3 أحرف على الأقل',
  errPassword: 'يرجى إدخال كلمة المرور',
  errPasswordMin: 'كلمة المرور يجب أن تحتوي على 8 أحرف على الأقل وحرف ورقم',
  errPasswordMismatch: 'كلمات المرور غير متطابقة',
  errManagerCode: 'يرجى إدخال كود المدير',
  errManagerCodeMin: 'كود المدير يجب أن يكون حرفين على الأقل',
  errInvalidEmail: 'تنسيق البريد الإلكتروني غير صالح',
  errUsernameTaken: 'اسم المستخدم أو البريد الإلكتروني مستخدم بالفعل',
  errCloudRegister: 'فشل التسجيل في السحابة',
  errCloudOfflineOrUnconfigured: 'تسجيل محلي فقط (بدون إنترنت).',
  errRegisterFailed: 'فشل التسجيل',
  errRegisterRetry: 'فشل التسجيل. يرجى المحاولة مرة أخرى.',
  registrationNotAllowed: 'هذا التثبيت مُعدّ مسبقاً. شركة واحدة لكل تثبيت. استخدم تسجيل الدخول.',
  errMachineBinding: 'هذا التثبيت مرتبط بجهاز آخر. التسجيل على هذا الحاسوب غير مسموح.',
  back: 'العودة',
  successTitle: 'تم التسجيل بنجاح!',
  successLocalOnly1:
    'تم إنشاء الحساب على هذا الجهاز. سيُدفع إلى Supabase عند توفر الإنترنت (قائمة انتظار سحابية). لوحة المسؤول تعرض فقط صفوف businesses السحابية.',
  successLocalOnly2: '',
  successCloudPending:
    'طُلب التسجيل في Supabase (حالة « في الانتظار »). يمكن للمسؤول الموافقة من لوحة الإدارة.',
  successEmailPending:
    'تم إنشاء حساب Auth. أكّد البريد إن لزم. يرى المسؤول صف businesses بعد الـ trigger / الدفع السحابي.',
  goToDashboard: 'الذهاب إلى لوحة التحكم',
  installBindingNotice: 'سيرتبط هذا التثبيت بهذا الجهاز فقط. لا تنسخ مجلد التطبيق إلى حاسوب آخر — استخدم المثبت الرسمي.',
  successOnboardingTitle: 'الخطوات التالية',
  successOnboardingManager: 'احفظ كود المدير: {code} (للوصول إلى إعدادات العمال).',
  successOnboardingCurrency: 'العملة المختارة: {currency}. يمكن تغييرها من الإعدادات.',
  successOnboardingStep1: 'أضف منتجاتك وسجّل مشترياتك.',
  successOnboardingStep2: 'اضبط نقطة البيع والعمال إن لزم.',
  successOnboardingStep3: 'استخدم كود المدير للوصول إلى الإعدادات المتقدمة.',
  stepBusinessType: 'نوع الشركة',
  stepBusinessInfo: 'معلومات الشركة والحساب',
  selectBusinessTypeTitle: 'نوع الشركة',
  selectBusinessTypeDesc: 'اختر نوع نشاطك التجاري',
  businessInfoTitle: 'معلومات الشركة والحساب',
  businessInfoDesc: 'أدخل معلومات شركتك وبيانات الحساب',
  next: 'التالي',
  previous: 'السابق',
  createAccount: 'إنشاء الحساب',
  alreadyHaveAccount: 'لديك حساب بالفعل؟',
  signInLink: 'تسجيل الدخول',
  showPassword: 'إظهار كلمة المرور',
  hidePassword: 'إخفاء كلمة المرور',
  passwordHint: '8 أحرف على الأقل، حرف ورقم',
  labelBusinessName: 'اسم الشركة *',
  placeholderBusinessName: 'أدخل اسم الشركة',
  labelLogo: 'شعار الشركة',
  removeLogo: 'إزالة',
  clickChooseLogo: 'انقر لاختيار الشعار',
  logoFormatHint: '(PNG, JPG, بحد أقصى 512 كيلوبايت)',
  labelOwnerName: 'اسم المالك *',
  placeholderOwnerName: 'أدخل اسم المالك',
  labelNif: 'رقم NIF *',
  placeholderNif: 'أدخل رقم NIF',
  labelPhone: 'رقم الهاتف *',
  placeholderPhone: 'أدخل رقم الهاتف',
  labelAddress: 'العنوان *',
  placeholderAddress: 'أدخل العنوان',
  labelCurrency: 'العملة *',
  currencyMRO: 'أوقية (MRO) — العملة القديمة',
  currencyMRU: 'أوقية (MRU) — العملة الجديدة',
  currencyHint: 'تُستخدم للأسعار والتقارير. يمكن تغييرها لاحقاً من الإعدادات.',
  labelEmail: 'البريد الإلكتروني *',
  placeholderEmail: 'أدخل البريد الإلكتروني',
  labelUsername: 'اسم المستخدم *',
  placeholderUsername: 'أدخل اسم المستخدم',
  labelPassword: 'كلمة المرور *',
  placeholderPassword: 'أدخل كلمة المرور',
  labelConfirmPassword: 'تأكيد كلمة المرور *',
  placeholderConfirmPassword: 'أكد كلمة المرور',
  labelManagerCode: 'كود المدير *',
  placeholderManagerCode: 'أدخل كود المدير (حرفان على الأقل)',
  managerCodeHint: 'سيتم استخدام هذا الكود للوصول إلى إعدادات إدارة العمال'
};
